export default "__VITE_ASSET__a3d94e7d__"